import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import InfoModal from "../../utils/components/InfoModal";

import "../../../styles/components/map/modals/ChargerInfoModal.scss";

class ChargerInfoModal extends Component {
  renderOperatorInfo() {
    const { operatorContact, operatorEmail } = this.props.info;

    return (
      <div className="info-container">
        <div className="info-item">
          <p>
            <Translate value="operatorInfo_networkPhone" />
          </p>
          <b>{operatorContact ? operatorContact : "-"}</b>
        </div>
        <div className="info-item">
          <p>
            <Translate value="operatorInfo_networkEmail" />
          </p>
          <b>{operatorEmail ? operatorEmail : "-"}</b>
        </div>
      </div>
    );
  }

  renderAvailabilityInfo() {
    // TODO: render custom availability info
  }

  render() {
    return (
      <InfoModal show={this.props.show} onHide={this.props.onHide}>
        <div id="chargerInfoModal">
          {this.props.mode === "operatorInfo"
            ? this.renderOperatorInfo()
            : this.renderAvailabilityInfo()}
        </div>
      </InfoModal>
    );
  }
}

export default ChargerInfoModal;
